import { FC } from "react";
import styles from "./ManagementPage.module.scss";
import { TgBlock } from "@/lib/ui/blocks/common/TgBlock";
import { PropertyExperts } from "@/lib/ui/blocks/common/PropertyExperts";
import { useTranslation } from "next-i18next";
import { CompanyBenefits } from "@/lib/ui/blocks/common/CompanyBenefits";
import { TopBlockManagement } from "@/lib/ui/blocks/page-specific/ManagementPage/TopBlockManagement";
import { HowWeWork } from "@/lib/ui/blocks/page-specific/ManagementPage/HowWeWork";
import { IncomeCalculation } from "@/lib/ui/blocks/page-specific/LandingInvest/IncomeCalculation";
import { ExamplesОbjects } from "@/lib/ui/blocks/page-specific/ManagementPage/ExamplesОbjects";
import { ManagementReviews } from "../../ui/blocks/page-specific/ManagementPage/ManagementReviews";
import { ManagementWhatWeOffer } from "../../ui/blocks/page-specific/ManagementPage/ManagementWhatWeOffer";
import { ManagementCalmness } from "../../ui/blocks/page-specific/ManagementPage/ManagementCalmness";
import { ManagementWeCare } from "../../ui/blocks/page-specific/ManagementPage/ManagementWeCare";
import { MANAGEMENT_EXPERTS } from "../../constants/experts";
import { ManagementExample } from "../../ui/blocks/page-specific/ManagementPage/ManagementExample";
import cl from 'classnames';
import { ManagementPopularity } from "@/lib/ui/blocks/page-specific/ManagementPage/ManagementPopularity";

export const ManagementPage: FC = () => {
    const { t } = useTranslation("index", { keyPrefix: "managementPage" });
    return (
      <section className={styles.managementPage}>
        <TopBlockManagement />
        <CompanyBenefits
            isPropertyManagement
            isWideText
            disableBackground
            removeLeaf
            theme={"light"}
            title="trustedManagement"
          />
          <HowWeWork />
          <ManagementPopularity />
          <div className={styles.container}>
            <IncomeCalculation 
              title="orderForecastTitle" 
              buttonLabel="orderForecastButton"
              expert="/images/team/management_expert.webp" 
              modalTitle="getIndividualCalculation"
              comment="Получить прогноз доходности объекта"
              sourceForm="request_rental_income_forecast"
              leadType="COOP"
            />
          </div>
          <ExamplesОbjects />
        <ManagementWeCare />
        <div className={styles.managementPage__experts}>
          <PropertyExperts
            title={t("expertsTitle")}
            type={"expert"}
            classname={styles.managementPage__experts_card}
            experts={MANAGEMENT_EXPERTS}
            leadType="COOP"
          />
        </div>
      <ManagementCalmness />
      <div className={cl(styles.managementPage__rel, styles.container)}>
        <ManagementExample />
      </div>
      <ManagementWhatWeOffer />
      <ManagementReviews />
      <TgBlock />
    </section>
  );
};
